<template>
    <div class="list-wrapper">
      <div class="content-wrapper">
        <div class="h-full">
          <XzTagGroup :data="statusWithAll" :active="outform.cooperationStatus" @handleClick="(v) => handleOutChange('cooperationStatus', v)">
            <span class="title">协同状态</span>
          </XzTagGroup>
          <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
            <xz-table ref="xzTable" :columns="columnLists" :data="data" :searchAttrs="searchAttrs"
              :searchVal.sync="outform.enterpriseName" :toolsAttrs="toolsAttrs" :drawerVisible.sync="drawerVisible"
              :scroll="{ x: '100%', y: scrollHeight }" :drawerWidth="460" @search="() => handleOutChange()" rowKey="id"
              @refresh="handleReset" @fullScreen="handleFullScreen" class="wrap">
              <template #drawer>
                <div style="flex: 1; overflow: auto" class="advanced-search">
                  <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :colon="false">
                    <a-form-model-item label="协同状态">
                      <a-select v-model="form.cooperationStatus" placeholder="请选择协同状态" allow-clear>
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option :value="1">已协同</a-select-option>
                        <a-select-option :value="2">已关闭</a-select-option>
                        <a-select-option :value="3">已失效</a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="协同类型">
                      <a-select v-model="form.cooperationType" placeholder="请选择协同类型" allow-clear>
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option :value="1">采购协同</a-select-option>
                        <a-select-option :value="2">销售协同</a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="协同企业名称">
                      <a-input v-model="form.enterpriseName" placeholder="请输入协同企业名称" allow-clear />
                    </a-form-model-item>
                    <a-form-model-item label="社会信用统一代码">
                      <a-input v-model="form.unifiedSocialCreditCode" placeholder="请输入社会信用统一代码" allow-clear />
                    </a-form-model-item>
                    <a-form-model-item label="小紫企业号">
                      <a-input v-model="form.tenantCode" placeholder="请输入小紫平台企业号" allow-clear />
                    </a-form-model-item>
                    <a-form-model-item label="创建人">
                      <a-input v-model="form.createUserName" placeholder="请输入创建人" allow-clear />
                    </a-form-model-item>
                    <a-form-model-item label="联系方式">
                      <a-input v-model="form.createUserPhone" placeholder="请输入联系方式" allow-clear />
                    </a-form-model-item>
                    <a-form-model-item label="更新开始时间">
                      <a-date-picker v-model="form.lastUpdateTimeStart" placeholder="请选择更新开始时间" valueFormat="x"
                        style="width: 100%;" allow-clear show-time>
                      </a-date-picker>
                    </a-form-model-item>
                    <a-form-model-item label="更新结束时间">
                      <a-date-picker v-model="form.lastUpdateTimeEnd" placeholder="请选择更新结束时间" valueFormat="x"
                        style="width: 100%;" allow-clear show-time>
                      </a-date-picker>
                    </a-form-model-item>
                  </a-form-model>
                </div>
                <div style="text-align: right; height: 68px; line-height: 68px">
                  <a-button @click="handleEmpty">
                    重置
                  </a-button>
                  <a-button type="primary" style="margin-left: 10px;" @click="handleAdvancedQuery">
                    确定
                  </a-button>
                </div>
              </template>
              <template #custom>
                <tableHeaderConfiguration businessType="cooperationEnterprise" :baseLists="baseLists" @updateColumnList="updateColumnList" />
              </template>
              <span slot="action" slot-scope="text, record">
                <a-popconfirm v-if="record.cooperationStatus === 1 && $withPermission('gongxutong:cooperation_enterprise:close')" placement="leftTop" ok-text="确认" cancel-text="取消" @confirm="handleClose(record)">
                  <template slot="title">
                    <div style="width: 249px;">当前已与该企业/组织建立外部协同，点击【确认】后，将无法再进行外部协同</div>
                  </template>
                  <a style="color:#F56C6C;">关闭</a>
                </a-popconfirm>
                <a-popconfirm v-if="record.cooperationStatus === 2 && $withPermission('gongxutong:cooperation_enterprise')" placement="leftTop" ok-text="确认" cancel-text="取消" @confirm="handleOpen(record)">
                  <template slot="title">
                    确认启用？
                  </template>
                  <a>启用</a>
                </a-popconfirm>
              </span>
            </xz-table>
          </div>
        </div>
      </div>
      <div class="pagination-wrapper">
        <a-pagination :current="page.pageNum" :total="total" :show-total="total => `共 ${total} 条`" show-size-changer :pageSizeOptions="['10', '20', '30', '50', '100']" show-quick-jumper :pageSize.sync="page.pageSize" @change="handleNumChange" @showSizeChange="handleSizeChange" />
      </div>
    </div>
</template>
<script>
import { cooperationEnterprisePageList, cooperationEnterpriseOpen, cooperationEnterpriseClose } from '@/api/cooperation';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import XzTagGroup from '../../../components/xiaozi-ui/xz-tag-group';
import * as Moment from 'dayjs';
import { mapGetters } from 'vuex';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';

const COMMON_COLUMNS = [
  {
    title: '协同状态',
    dataIndex: 'cooperationStatusDesc',
    key: 'cooperationStatusDesc',
    width: 100,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '协同类型',
    dataIndex: 'cooperationTypeDesc',
    key: 'cooperationTypeDesc',
    width: 80,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '协同企业名称',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '社会信用统一代码',
    dataIndex: 'unifiedSocialCreditCode',
    key: 'unifiedSocialCreditCode',
    width: 100,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '小紫企业号',
    dataIndex: 'tenantCode',
    key: 'tenantCode',
    width: 180,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '创建人',
    dataIndex: 'createUserName',
    key: 'createUserName',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '联系方式',
    dataIndex: 'createUserPhone',
    key: 'createUserPhone',
    width: 100,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '更新时间',
    dataIndex: 'lastUpdateTime',
    key: 'lastUpdateTime',
    width: 170,
    ellipsis: true,
    customRender: (text) => {
      return text ? Moment(text * 1).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
];

export default {
  name: 'CooperationEnterprise',
  components: {
    xzTable,
    XzTagGroup,
    tableHeaderConfiguration,
  },
  computed: {
    ...mapGetters(['actionPermissionMap']),
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        advancedSearch: true,
        custom: true,
      };
    },
  },
  watch: {
    drawerVisible (v) {
      if (v) {
        this.form = { ...this.outform };
      }
    },
  },
  data () {
    return {
      columnLists: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [...COMMON_COLUMNS],
      data: [],
      outform: {
        cooperationStatus: '',
        cooperationType: '',
        enterpriseName: '',
        unifiedSocialCreditCode: '',
        tenantCode: '',
        createUserName: '',
        createUserPhone: '',
        lastUpdateTimeStart: '',
        lastUpdateTimeEnd: '',
      },
      form: {
        cooperationStatus: '',
        cooperationType: '',
        enterpriseName: '',
        unifiedSocialCreditCode: '',
        tenantCode: '',
        createUserName: '',
        createUserPhone: '',
        lastUpdateTimeStart: '',
        lastUpdateTimeEnd: '',
      },
      total: 0,
      searchAttrs: {
        show: true,
        placeholder: '请输入企业名称',
        data: 'enterpriseName',
      },
      drawerVisible: false,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      statusWithAll: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '已协同',
          value: 1,
        },
        {
          label: '已关闭',
          value: 2,
        },
        {
          label: '已失效',
          value: 3,
        },
      ],
      page: {
        pageSize: 10,
        pageNum: 1,
      },
      scrollHeight: 600,
      isFullScreen: false,
    };
  },
  methods: {
    updateColumnList (columnList) {
      this.columnLists = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 100,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    handleEmpty () {
      this.form = this.$options.data().form;
    },
    handleReset () {
      this.outform = {
        ...this.$options.data().form,
      };

      this.page.pageNum = 1;
      this.page.pageSize = 10;

      this.handleSearch();
    },
    handleAdvancedQuery () {
      this.page.pageNum = 1;

      this.form.cooperationStatus = this.form.cooperationStatus === undefined ? '' : this.form.cooperationStatus;

      this.handleSearch(this.form);

      this.$nextTick(() => {
        this.outform = { ...this.form };
      });
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;

      this.handleSearch();
    },
    handleNumChange (num) {
      this.page.pageNum = num;

      this.handleSearch();
    },
    async handleSearch (form = this.outform) {
      this.data = [];
      const { body } = await cooperationEnterprisePageList({
        ...form,
        ...this.page,
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'DESC',
        }],
      });

      this.data = body?.list || [];

      this.total = Number(body?.total || 0);

      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    },
    async handleClose (record) {
      await cooperationEnterpriseClose({
        id: record.id,
      });

      this.handleSearch();
    },
    async handleOpen (record) {
      await cooperationEnterpriseOpen({
        id: record.id,
      });

      this.handleSearch();
    },
    handleOutChange (key, o) {
      if (key) {
        this.outform[key] = o.value;
      }

      this.page.pageNum = 1;

      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleFullScreen (flag) {
      this.isFullScreen = flag;
    },
  },
  mounted () {
    this.handleSearch();
  },
};
</script>
  <style scoped lang="scss">
  @mixin tag_round() {
    padding: 4px 8px;
    border-radius: 4px;
  }

  .list-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .content-wrapper {
      flex: 1;
      overflow: hidden;
      padding: 0 0 8px;

      .h-full {
        height: 100%;
        background-color: #fff;
        display: flex;
        flex-direction: column;

        .title {
          font-size: 14px;
          font-weight: 600;
          padding-right: 2em;
        }

        .table-wrapper {
          padding: 16px 12px;
          flex: 1;
          overflow: auto;

          .ant-radio-button-wrapper {
            border-width: 0;
            background-color: #F2F4F7;

            &.active-radio {
              border-color: #E2F3FE;
              background-color: #E2F3FE;
              color: #237FFA;
            }
          }

          .ant-radio-button-wrapper:not(:first-child)::before {
            width: 0;
          }

          .code {
            cursor: pointer;
            color: #237FFA;
          }

          .status-0,
          .status-5 {
            @include tag_round();
            color: #1F2733;
            background-color: #F2F4F7;
          }

          .status-1,
          .status-3,
          .status-6 {
            @include tag_round();
            background-color: #E2F3FE;
            color: #237FFA;
          }

          .status-4 {
            @include tag_round();
            background-color: #E5FEEB;
            color: #14CA64;
          }

          .status-2,
          .status-7 {
            @include tag_round();
            background-color: #FEE9E5;
            color: #FF5959;
          }
        }
      }
    }
  }

  .table-wrapper.fullscreen {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0px;
    z-index: 100;
    background: #FFFFFF;
  }

  /deep/.ant-table-body::-webkit-scrollbar {
    height: 12px;
    width: 12px;
  }

  /deep/ .ant-table-body::-webkit-scrollbar-thumb {
    border-radius: 8px;
    box-shadow: inset 0 0 5px #C9CED6;
    background: #C9CED6;
  }

  //鼠标移入样式
  /deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
    background: #C9CED6;
  }

  .advanced-search {
    .ant-form-item {
      margin-bottom: 8px;
    }
  }

  /deep/.ant-drawer-body {
    padding: 16px;
  }
  </style>
